export function setupBluekai() {
  if (
    window.bluekaiHelper
    && window.bluekaiHelper.blueKaiTag
  ) {
    return false;
  }

  try {
    window.bluekaiHelper = {
      blueKaiReady: false,
      blueKaiQueue: [],
      blueKaiTag: function blueKaiTag(id: any, phints: any) {
        if (!bluekaiHelper.blueKaiReady) {
          return bluekaiHelper.blueKaiQueue.push(arguments);
        }

        var id = arguments[0];
        var phints = arguments[1];

        if (phints) {
          Object
            .keys(phints)
            .filter(function (key) {
              return phints[key] != null;
            })
            .forEach(function (key) {
              bk_addPageCtx(key, phints[key]);
            });
        }

        return bk_doJSTag(id, 1);
      }
    };

    window.bk_allow_multiple_calls = true;
    window.bk_use_multiple_iframes = true;
    window.bk_async = function () {
      bluekaiHelper.blueKaiReady = true;
      while (bluekaiHelper.blueKaiQueue.length > 0) {
        bluekaiHelper.blueKaiTag.apply(null, bluekaiHelper.blueKaiQueue.shift());
      }
    };
  } catch (err) {
    console.error(err);
  }
};

export function sendBluekeiData(event: any, tagId = 77969) {
  const { category, action, label } = event;
  try {
    var phints = {
      ec: category,
      ea: action,
      el: label
    };
    bluekaiHelper.blueKaiTag(tagId, phints);
  } catch (err) {
    console.error(err);
  }
};

export function sendDigestMessage(userCpfData: any) {
  userCpfData = userCpfData && userCpfData.length && userCpfData.replace(/\D*/gi, '') || false;

  if (
    !userCpfData
    || (
      userCpfData
      && userCpfData.length !== 11
    )) {
    return false;
  }

  function digestMessage(message: any) {
    const msgUint8 = new TextEncoder().encode(message);
    const hashBuffer = crypto.subtle.digest('SHA-256', msgUint8);
    return hashBuffer;
  }

  digestMessage(userCpfData).then(function (hashBuffer) {
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map(function (b) {
        return b
          .toString(16)
          .padStart(2, '0');
      })
      .join('')
      .toUpperCase();

    // Ativação das tags de ID swap do Bluekai após cada lead
    dataLayer.push({
      'event': 'idswapevent',
      'idphint': hashHex
    });
  });
};

export function sendPHInt(id: any) {
  try {
    var phints = {
      id
    };

    bluekaiHelper.blueKaiTag(77931, phints);
  } catch (err) {
    console.error(err);
  }
};
